<template>

  <ui-card-insight
    name="overview.time_visualization_insights"
    :error="error"
    padded
  >
    <div v-if="data && data.length > 0">
      <div class="description">{{ dayFilterLabel }}</div>
      <div v-for="(item, index) in data" :key="index" class="level insights-item">
        <div class="level-left">
          <div class="level-item insights-item-type">
            <i class="material-icons" v-if="icons[item.type]">{{ icons[item.type] }}</i>
            {{ item.type }}
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">{{ item.duration }}</div>
        </div>
      </div>
    </div>

    <div v-else-if="isLoading">
      <div class="blokk shimmer blokk-description">
        -----&#x20;--------&#x20;---------&#x20;----&#x20;---&#x20;-----------
      </div>
      <div class="blokk shimmer blokk-insights-item">
        <div>-&#x20;-----</div>
        <div>------</div>
      </div>
      <div class="blokk shimmer blokk-insights-item">
        <div>-&#x20;-----</div>
        <div>-----</div>
      </div>
      <div class="blokk shimmer blokk-insights-item">
        <div>-&#x20;-------</div>
        <div>-----</div>
      </div>
      <div class="blokk shimmer blokk-insights-item">
        <div>-&#x20;---</div>
        <div>------</div>
      </div>
    </div>

  </ui-card-insight>

</template>

<script>
import { assignIn } from 'lodash';
import { map, sortBy, zipObject, flow } from 'lodash/fp';
import icons from 'utils/icons';
import { card } from 'views/mixins'

export default {

  extends: card('filter-dates', 'filter-days'),

  data() {
    return {
      icons
    };
  },

  methods: {
    makeQuery(params) {
      return {
        app_id: params.appId,
        transformations: [],
        sets: [
          {
            store: 'event_time_agg_all_hour',
            measures: [
              {
                measure: 'duration_avg_all_users',
                agg: 'none',
                custom_id: 'duration'
              }
            ],
            dimensions: [
              {
                dim: 'event_significance',
                custom_id: 'type'
              }
            ],
            filters: [
              {
                scope: 'req',
                type: 'range',
                dim: 'isotime',
                begin: params.from,
                end: params.to
              },
              {
                scope: 'req',
                type: 'values',
                dim: 'day_of_week',
                values: params.domain
              }
            ]
          }
        ]
      };
    },

    parseData(set) {
      let fields = set.fields;
      let rows = set.rows;

      fields = map(field => field.custom_id)(fields);

      rows = flow(
        map(x => {
          const item = zipObject(fields, x);

          return assignIn({}, item, {
            duration: this.formatDuration(item.duration)
          });
        }),
        sortBy(this.sortByType)
      )(rows);

      return rows;
    },

    sortByType(o) {
      const preferredOrder = ['home', 'work', 'transport', 'other'];

      return preferredOrder.indexOf(o.type);
    },

    formatDuration(duration) {
      const h = Math.floor(duration);
      const m = Math.round((duration - h) * 60);

      return `${h}h ${m}m`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.card-header {
  & + .card-content {
    padding-top: 0;
  }
}

.description {
  margin-bottom: 1.5rem;
}

.insights-item {
  font-size: $size-small;
  line-height: 1.33;
  margin-bottom: .625rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.insights-item-type {
  text-transform: capitalize;

  i {
    font-size: $size-small;
    vertical-align: middle;
    margin-right: .5rem;
  }
}

.blokk-insights-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 0.6rem;
}

.blokk-description {
  font-size: $size-4;
  line-height: 1;
  margin-bottom: 1.5rem;
}

</style>